import React, {
  useCallback,
} from 'react'
import PropTypes from 'prop-types'
import {
  FormattedMessage,
  useIntl,
} from 'react-intl'

import CheckmarkIcon from './img/checkmark-icon.svg'

import Locale from './locale'
import Styles from './styles.scss'

const GPC_ARTICLE_URL = 'https://termly.io/resources/articles/what-is-global-privacy-control/'

export default function GPCNotification({ handleClose }) {
  const { formatMessage } = useIntl()

  const onClick = useCallback((e) => {
    e.stopPropagation()

    handleClose()
  }, [handleClose])

  return (
    <div
      className={ Styles.root }
      role="alert"
    >
      <div className={ Styles.icon }>
        <img
          alt=""
          src={ CheckmarkIcon }
        />
      </div>
      <span className={ Styles.message }>
        <FormattedMessage
          { ...Locale.message }
        />
        <a
          className={ Styles.link }
          href={ GPC_ARTICLE_URL }
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className={ Styles.questionMark }>?</span>
        </a>
      </span>
      <button
        aria-label={ formatMessage(Locale.closeAriaLabel) }
        className={ Styles.closeButton }
        onClick={ onClick }
        type="button"
      >
        ×
      </button>
    </div>
  )
}

GPCNotification.propTypes = {
  handleClose: PropTypes.func.isRequired,
}
